import axios from "axios.js";

export const SET_API_VERSION = "[APP] SET_API_VERSION";
export const SET_APP_VERSION = "[APP] SET_APP_VERSION";

const FRONT_VERSION = process.env.REACT_APP_APP_VERSION || "16.2";

export function initAppVersion() {
  return (dispatch) => {
    dispatch({ type: SET_APP_VERSION, payload: FRONT_VERSION });
    return FRONT_VERSION;
  };
}

export function fetchApiVersion() {
  return (dispatch) =>
    axios
      .get("/version")
      .then((response) => {
        const version = response?.data?.version;
        if (version) {
          dispatch({ type: SET_API_VERSION, payload: version });
        }
        return version;
      })
      .catch((error) => {
        console.error("Unable to retrieve API version", error);
        throw error;
      });
}


